import {
  FilterCondition,
  FilterDTO,
  FilterOperator,
  IPagedResultDTOOfClientDTO,
  SortDirection,
} from "./../../models/models.swagger.generated";
import { AuthService } from "../auth.service";
import { Observable, of } from "rxjs";
import { Injectable } from "@angular/core";
import {
  ClientClient,
  ClientDTO,
  PagedResultDTOOfClientDTO,
} from "src/app/base/models/models.swagger.generated";
import { catchError, tap } from "rxjs/operators";
import { ToastService } from "src/app/base/services/toast.service";
import { SpinnerService } from "src/app/base/spinner/spinner.service";
import { ErrorType } from "src/app/core/routing/error-types";
import { IAdaptorService } from "../../shared/syncfusion/adaptor-service.interface";
import { IPagedItems } from "../../shared/syncfusion/paged-items.interface";

@Injectable({
  providedIn: "root",
})
export class ClientService implements IAdaptorService{
  public clients: ClientDTO[] = [];
  public numberOfClients: number = 0;

  public get selectedClient(): ClientDTO | null {
    if (this.authService.hasUserClientAssigned()) {
      return this.authService.getUserInfo()?.client || null;
    }
    return this._selectedClient;
  }

  public set selectedClient(client: ClientDTO | null) {
    if (this.authService.hasUserClientAssigned())
    {
      return;
    }
    this._selectedClient = client;
  }

  private _selectedClient: ClientDTO | null = null;
  constructor(
    private authService: AuthService,
    private clientAdministrationClient: ClientClient,
    private toastService: ToastService,
    private spinnerService: SpinnerService,
  ) { }

  public searchClients(
    searchTerm: string,
    take: number,
  ): Observable<IPagedResultDTOOfClientDTO> {
    const filters = [
      new FilterDTO({
        isComplex: false,
        field: "IsActive",
        operator: FilterOperator.Equal,
        value: "true",
      }),
    ];
    searchTerm = searchTerm?.trim();
    if (searchTerm != null && searchTerm.length) {
      filters.push(
        new FilterDTO({
          isComplex: true,
          condition: FilterCondition.Or,
          predicates: [
            new FilterDTO({
              isComplex: false,
              field: "Name",
              operator: FilterOperator.Contains,
              value: searchTerm,
            }),
          ],
        }),
      );
    }

    return this.getAccessibleClients(filters, 0, take, true);
  }

  // this method is used for dynamic management components forms where a client autocomplete field is used.
  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string | undefined, sortDirection: SortDirection | undefined): Observable<IPagedItems | null> {
    // if a clientid is set in the form but there is not data set yet avaialable for the autocoplete, the autocomplete looks for the item by id instead of name, so the value of the filter is a number instead of a string. In this case we do not want to add the IsActive filter, because it will not be applied anyway.
    if (filters?.length > 0 && typeof (filters[0].value) === 'number') {
      if (this.selectedClient?.id === filters[0].value) {
        return of({
          items: [this.selectedClient],
          totalNumberOfItems: 1,
        });
      }
    }
    return this.getAccessibleClients(filters, skip, take);
  }
  public addRecord(data:any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  public updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  public deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  private getAccessibleClients(
    filter: FilterDTO[] | null = null,
    skip = 0,
    take = 0,
    skipAutoSelect = false,
  ): Observable<IPagedResultDTOOfClientDTO> {
    const loggedInUser = this.authService.getUserInfo();
    if (loggedInUser?.client) {
      this.selectedClient = loggedInUser.client;
      this.clients = [loggedInUser.client];
      return of({
        items: [loggedInUser.client],
        totalNumberOfItems: 1,
      } as PagedResultDTOOfClientDTO);
    } else if (this.authService.isUserAdmin()) {
      this.spinnerService.show();

      if (filter == null) {
        filter = [
          new FilterDTO({
            isComplex: false,
            field: "IsActive",
            operator: FilterOperator.Equal,
            value: "true",
          }),
        ];
      }
      return this.clientAdministrationClient
        .searchClients(filter, 0, 0, "name", SortDirection.Ascending)
        .pipe(
          tap((pagedResult: PagedResultDTOOfClientDTO | null) => {
            this.spinnerService.hide();
            if (!skipAutoSelect) {
              this.clients = pagedResult?.items || [];
              this.numberOfClients = pagedResult?.totalNumberOfItems || 0;
              if (this.numberOfClients === 1) {
                this.selectedClient = this.clients[0];
              }
            }
          }),
          catchError((error: any) => {
            this.spinnerService.hide();
            if (
              !this.toastService.doesErrorExistAlready(ErrorType.serverError)
            ) {
              this.toastService.showError(
                "i18n.errors.server-error.title",
                "i18n.errors.server-error.message",
                "",
                ErrorType.serverError,
              );
            }
            return of(error);
          }),
        );
    }
    return of({
      items: [],
      totalNumberOfItems: 0,
    } as IPagedResultDTOOfClientDTO);
  }
}
